angular.module('cimerFrontEndApp').controller('EditQuestionModalCtrl', ['$scope', '$uibModalInstance', 'question', 'directorID', 'TextEditorService', 'idFactory', function ($scope, $uibModalInstance, question, directorID, TextEditorService, idFactory) {

    "use strict";

    $scope.questionType = ''; //text,radio,matrix
    $scope.temp = {};
    $scope.tinymceOptions = TextEditorService.GetTextEditorConfig();
    $scope.isCustom = directorID !== null;
    $scope.questionLabelMaxLength = 5000;
    $scope.questionPromptMaxLength = 5000;
    $scope.matrixQuestionPromptMaxLength = 5000;
    $scope.scaleAnswerMaxLength = 600;
    $scope.questionPromptLength = 0;
    $scope.matrixQuestionPromptLength = 0;
    $scope.scaleAnswerLengths = [];
    $scope.matrixIndividualQuestionPromptLengths = [];

    var oldScaleObj = null;

    var setOtherAnswerEnabled = function () {
        var hasOtherAnswer = false;
        var otherAnswerIndex = -1;
        for (var i = 0; i < $scope.temp.scale.QuestionScale.length; i++) {
            if ($scope.temp.scale.QuestionScale[i].IsOtherAnswer) {
                hasOtherAnswer = true;
                otherAnswerIndex = i;
                break;
            }
        }
        for (var j = 0; j < $scope.temp.scale.QuestionScale.length; j++) {
            if (hasOtherAnswer && otherAnswerIndex !== j) {
                $scope.temp.scale.QuestionScale[j].OtherAnswerEnabled = false;
            }
            else {
                $scope.temp.scale.QuestionScale[j].OtherAnswerEnabled = true;
            }
        }
    };

    var setTempScaleInfo = function (question) {
        $scope.temp.scale = {
            QuestionScaleID: question.QuestionScaleID,
            QuestionScale: question.QuestionScale,
            OwnerID: question.OwnerID
        };
        for (var i = 0; i < $scope.temp.scale.QuestionScale.length; i++) { // set length of existing scale answers
            $scope.scaleAnswerLengths.push(TextEditorService.GetPlainTextLength($scope.temp.scale.QuestionScale[i].AnswerText));
        }
        setOtherAnswerEnabled();
    };

    var isMatrix, isRadio, isMultipleChoice;
    isMatrix = isRadio = isMultipleChoice = false;

    var _parseQuestion = function (questionObj) {

        switch (questionObj.typeID) {
        case 0:
            isMatrix = true;
            break;
        case 1:
            isRadio = true;
            break;
        case 4:
            isMultipleChoice = true;
            break;
            //isText = 3 (not used)
        }

        $scope.hasScaleOption = isRadio || isMatrix || isMultipleChoice;

        $scope.questionType = questionObj.text || questionObj.type; //it's not very consistent :/
        if (isMatrix) {
            setTempScaleInfo(questionObj.details.Questions[0]); 
            oldScaleObj = angular.copy($scope.temp.scale);
            questionObj.details.QuestionLabel = questionObj.details.Questions[0].QuestionLabel;
            for (var i = 0; i < questionObj.details.Questions.length; i++) {
                $scope.matrixIndividualQuestionPromptLengths.push(TextEditorService.GetPlainTextLength(questionObj.details.Questions[i].Text));
            }
            $scope.matrixQuestionPromptLength = TextEditorService.GetPlainTextLength(questionObj.details.QuestionPromptText);
        }
        else if ($scope.hasScaleOption) { 
            setTempScaleInfo(questionObj.details);
            oldScaleObj = angular.copy($scope.temp.scale);
            $scope.questionPromptLength = TextEditorService.GetPlainTextLength(questionObj.details.Text);
        }
        
        return questionObj;
    };

    var _finishSaveQuestion = function () {
        $scope.question.description = $scope.question.details.QuestionLabel;
        if ($scope.questionType !== 'Text') {
            compareScaleObjects();
        }
        if ($scope.questionType === 'Matrix') {
            for (var i = 0; i < $scope.question.details.Questions.length; i++) {
                $scope.question.details.Questions[i].QuestionLabel = $scope.question.details.QuestionLabel;
                // If there is a question that doesn't have an ID yet, assign it one
                if ($scope.question.getID(i) === null) {
                    $scope.question.details.Questions[i].tempID = idFactory.getNewQuestionID();
                }
            }
        }

        $uibModalInstance.close($scope.question);
    };

    $scope.question = _parseQuestion(angular.copy(question));

    $scope.addScaleItem = function () {
        if (!$scope.temp.scale.hasOwnProperty('QuestionScale') || $scope.temp.scale.QuestionScale === undefined) {
            $scope.temp.scale.QuestionScale = [];
        }
        var tempNumber = $scope.temp.scale.QuestionScale.length + 1;
        $scope.temp.scale.QuestionScale.push({
            ScaleAnswerID: null,
            AnswerNumber: tempNumber,
            AnswerText: '',
            NotApplicable: false,
            CompositeScoreRecodeValue: null,
            QuestionBranch: {
                QuestionBranchID: null,
                TempBranchID: null,
                getID: function () { return this.QuestionBranchID || this.TempBranchID; }
            },
            tempID: idFactory.getNewScaleAnswerID(),
            getID: function () { return this.ScaleAnswerID || this.tempID; },
            IsOtherAnswer: false
        });
        $scope.scaleAnswerLengths.push(0);
        setOtherAnswerEnabled()
    };
    $scope.removeScaleItem = function (index) {
        $scope.temp.scale.QuestionScale.splice(index, 1);
        $scope.scaleAnswerLengths.splice(index, 1);
        setOtherAnswerEnabled();
    };
    $scope.addMatrixQuestion = function () {
        if (!$scope.question.details.hasOwnProperty('Questions') || $scope.question.details.Questions === undefined) {
            $scope.question.details.Questions = [];
        }
        var newQuestion = {
            QuestionID: null,
            QuestionPromptID: $scope.question.details.QuestionPromptID,
            QuestionPromptText: $scope.question.details.QuestionPromptText,
            QuestionTypeID: 1, //Radio
            QuestionType: 'Single-Select', //radio
            Text: '',           //actual question
            QuestionScaleID: $scope.temp.scale.QuestionScaleID,
            QuestionScale: $scope.temp.scale.QuestionScale,
            OwnerID: $scope.question.details.OwnerID,
            QuestionRoleID: null, // let the caller determine what this should be
            SectionIndexID: null,
            QuestionBranches: $scope.question.details.Questions[0].QuestionBranches,
            tempID: null,
            Required: false // this isn't an option for matrix so default to false
        };
        $scope.question.details.Questions.push(newQuestion);
        $scope.matrixIndividualQuestionPromptLengths.push(0);
    };
    $scope.removeMatrixQuestion = function (index) {
        $scope.question.details.Questions.splice(index, 1);
        $scope.matrixIndividualQuestionPromptLengths.splice(index, 1);
    };
    //matrix only
    $scope.updateScaleText = function (index) {
        if (!isMatrix) {
            return;
        }

        for (var i = 0; i < $scope.question.details.Questions.length; i++) {
            $scope.question.details.Questions[i].QuestionScale[index].AnswerText = $scope.temp.scale.QuestionScale[index].AnswerText;
            $scope.question.details.Questions[i].QuestionScale[index].AnswerTextPlainText = TextEditorService.ConvertToPlainTextSync($scope.temp.scale.QuestionScale[index].AnswerText);
        }
    };
    //matrix only
    $scope.updateNotApplicable = function (index) {
        if (!isMatrix) {
            return;
        }

        for (var i = 0; i < $scope.question.details.Questions.length; i++) {
            $scope.question.details.Questions[i].QuestionScale[index].NotApplicable = $scope.temp.scale.QuestionScale[index].NotApplicable;
        }
    };
    //matrix only
    $scope.updateCompositeScoreRecodeValue = function (index) {
        if (!isMatrix) {
            return;
        }

        for (var i = 0; i < $scope.question.details.Questions.length; i++) {
            $scope.question.details.Questions[i].QuestionScale[index].CompositeScoreRecodeValue = $scope.temp.scale.QuestionScale[index].CompositeScoreRecodeValue;
        }
    };

    // Only update scale object if it has changed
    var compareScaleObjects = function () {
        var changesMade = false;
        var i;
        //did length change?
        if ($scope.temp.scale.QuestionScale.length !== oldScaleObj.QuestionScale.length) {
            changesMade = true;
        }
        //if not, then check for text changes
        else {
            for (i = 0; i < $scope.temp.scale.QuestionScale.length; i++) {
                if ($scope.temp.scale.QuestionScale[i].AnswerText !== oldScaleObj.QuestionScale[i].AnswerText) {
                    changesMade = true;
                }
                if ($scope.temp.scale.QuestionScale[i].NotApplicable !== oldScaleObj.QuestionScale[i].NotApplicable) {
                    changesMade = true;
                }
                if ($scope.temp.scale.QuestionScale[i].CompositeScoreRecodeValue !== oldScaleObj.QuestionScale[i].CompositeScoreRecodeValue) {
                    changesMade = true;
                }
            }
        }
        //apply changes to all questions
        if (changesMade) {
            var newScale = [];
            var tempObj = {};
            for (i = 0; i < $scope.temp.scale.QuestionScale.length; i++) {
                tempObj = {
                    ScaleAnswerID: $scope.temp.scale.QuestionScale[i].ScaleAnswerID,
                    AnswerNumber: i + 1,
                    AnswerText: $scope.temp.scale.QuestionScale[i].AnswerText,
                    NotApplicable: $scope.temp.scale.QuestionScale[i].NotApplicable,
                    CompositeScoreRecodeValue: $scope.temp.scale.QuestionScale[i].CompositeScoreRecodeValue,
                    AnswerTextPlainText: TextEditorService.ConvertToPlainTextSync($scope.temp.scale.QuestionScale[i].AnswerText),
                    QuestionBranch: $scope.temp.scale.QuestionScale[i].QuestionBranch, // do copy the whole object
                    tempID: $scope.temp.scale.QuestionScale[i].tempID,
                    getID: function () { return this.ScaleAnswerID || this.tempID; },
                    OtherAnswerEnabled: $scope.temp.scale.QuestionScale[i].OtherAnswerEnabled,
                    IsOtherAnswer: $scope.temp.scale.QuestionScale[i].IsOtherAnswer
                };
               
                if (tempObj.getID() === null) {
                    tempObj.tempID = idFactory.getNewScaleAnswerID();
                }
                newScale.push(tempObj);
            }

            $scope.question.details.QuestionScaleID = $scope.temp.scale.QuestionScaleID;
            $scope.question.details.QuestionScale = newScale;
            $scope.question.details.OwnerID = directorID;
            if ($scope.questionType === 'Matrix') {
                for (var j = 0; j < $scope.question.details.Questions.length; j++) {
                    $scope.question.details.Questions[j].QuestionScaleID = $scope.temp.scale.QuestionScaleID;
                    $scope.question.details.Questions[j].QuestionScale = newScale;
                    $scope.question.details.Questions[j].OwnerID = directorID;
                }
            }
        }
    };

    $scope.updateIsOtherAnswer = function (index) {
        if (isMatrix) { // do not run for matrix, matrix cannot have other options
            return;
        }
        var isOtherAnswer = $scope.temp.scale.QuestionScale[index].IsOtherAnswer;
        for (var i = 0; i < $scope.temp.scale.QuestionScale.length; i++) {
            if (isOtherAnswer && index !== i) {
                $scope.temp.scale.QuestionScale[i].OtherAnswerEnabled = false;
            }
            else {
                $scope.temp.scale.QuestionScale[i].OtherAnswerEnabled = true;
            }
        }
    };

    $scope.formSubmitted = false;
    $scope.saveQuestion = function () {

        $scope.formSubmitted = true;

        if (!$scope.editQuestionForm.$invalid) {
            var prompt = $scope.question.details.Text;  // default to the non-matrix prompt
            if ($scope.questionType === 'Matrix') {
                prompt = $scope.question.details.QuestionPromptText;
            }
            TextEditorService.ConvertToPlainText(prompt)
                .then(function (result) {
                    if ($scope.question.details.QuestionLabel === '' || $scope.question.details.QuestionLabel === null) {
                        $scope.question.details.QuestionLabel = result;
                    }
                    if ($scope.questionType === 'Matrix') { $scope.question.details.QuestionPromptTextPlain = result; }
                    else { $scope.question.details.TextPlain = result; }
                    _finishSaveQuestion();
                });
            return;
        }
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.checkQuestionPromptLength = function () {
        $scope.questionPromptLength = TextEditorService.GetPlainTextLength($scope.question.details.Text);
        $scope.updateValidity($scope.questionPromptLength, $scope.questionPromptMaxLength, $scope.editQuestionForm.questionForm.questionText, "questionText");
    };

    $scope.checkMatrixQuestionPromptLength = function () {
        $scope.matrixQuestionPromptLength = TextEditorService.GetPlainTextLength($scope.question.details.QuestionPromptText);
        $scope.updateValidity($scope.matrixQuestionPromptLength, $scope.matrixQuestionPromptMaxLength, $scope.editQuestionForm.questionForm.matrixQuestionText, "matrixQuestionText");
    };

    $scope.checkScaleAnswerLength = function (index) {
        $scope.scaleAnswerLengths[index] = TextEditorService.GetPlainTextLength($scope.temp.scale.QuestionScale[index].AnswerText);
        $scope.updateValidity($scope.scaleAnswerLengths[index], $scope.scaleAnswerMaxLength, $scope.editQuestionForm.questionForm['radioScaleForm_' + index].text, "text");
    };

    $scope.checkMatrixIndividualQuestionPromptLength = function (index) {
        $scope.matrixIndividualQuestionPromptLengths[index] = TextEditorService.GetPlainTextLength($scope.question.details.Questions[index].Text);
        $scope.updateValidity($scope.matrixIndividualQuestionPromptLengths[index], $scope.questionPromptMaxLength, $scope.editQuestionForm.questionForm['matrixPromptForm_' + index].text, "text");
    };

    $scope.updateValidity = function (fieldLength, fieldMax, form, fieldName) {
        if (fieldLength > fieldMax) {
            form.$setValidity(fieldName, false);
        }
        else {
            form.$setValidity(fieldName, true);
        }
    };
}]);
